// --- Modules
import Node, { payload } from './Node';

class NetworkDevice extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Network Device'
    });
  }
};

export default {
  create: (opts) => {
    let item = new NetworkDevice(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
